module.exports = __webpack_public_path__ + "img/hotel-vila-gale-ericeira.a05dc000.jpg";